/* ============================================================
   Azalay — أزرار الطلب بالدفع عند الاستلام
   1) زر الطلب داخل بطاقة الشراء (#az-cod-slot)
   2) شريط الطلب الثابت (#azOrderBar / #azOrderFab)
   3) زر السلة (#azCartCheckout)
   4) فتح الاستمارة تلقائيًا عند الوصول بالرابط ‎?order=1
   الاستمارة من تطبيق EasySell وهي تُنشئ الطلب مباشرة في Shopify
   دون المرور بصفحة الدفع. وإن غاب التطبيق يعود إلى المسار العادي.
   ============================================================ */
(function () {
  var CTA_TEXT = 'تأكيد الطلب — الدفع عند الاستلام';

  function findEasySellTrigger() {
    return document.querySelector('.es-sticky-btn') ||
           document.querySelector('.es-cta-btn') ||
           document.querySelector('.es-button');
  }

  function isModalOpen() {
    var m = document.querySelector('.es-modal');
    return !!m && getComputedStyle(m).display !== 'none';
  }

  function fallbackToCheckout(el, err, originalHTML) {
    el.disabled = true;
    el.innerHTML = '<span class="azp-fab__main">جاري التحويل…</span>';
    fetch(window.location.pathname.split('?')[0] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = null, i;
        for (i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        if (!v) v = p.variants[0];
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        window.location.href = '/checkout';
      })
      .catch(function () {
        el.disabled = false;
        el.innerHTML = originalHTML;
        if (err) err.style.display = 'block';
      });
  }

  function openOrder(el, err, originalHTML) {
    var trigger = findEasySellTrigger();
    if (trigger) {
      if (err) err.style.display = 'none';
      trigger.click();
      return;
    }
    fallbackToCheckout(el, err, originalHTML);
  }

  /* ---------- 1) زر الطلب داخل بطاقة الشراء ---------- */
  var slot = document.getElementById('az-cod-slot');
  if (slot && slot.dataset.azReady !== '1') {
    slot.dataset.azReady = '1';
    slot.innerHTML =
      '<p class="azp-ftitle">أكمل طلبك في خطوة واحدة</p>' +
      '<p class="azp-fnote">تملأ معلوماتك، تضغط تأكيد، ويصلنا الطلب مباشرة — بلا حساب ولا بطاقة بنكية.</p>' +
      '<button type="button" class="azp-cta" id="azCodBtn">' + CTA_TEXT + '</button>' +
      '<p class="azp-secure">معلوماتك تُستعمل للتوصيل فقط</p>' +
      '<p class="azp-err" id="azCodErr" role="alert">وقع خطأ، المرجو المحاولة مرة أخرى.</p>';

    var btn = document.getElementById('azCodBtn');
    var err = document.getElementById('azCodErr');
    var btnHTML = btn.innerHTML;
    btn.addEventListener('click', function () { openOrder(btn, err, btnHTML); });
  }

  /* ---------- 2) شريط الطلب الثابت ---------- */
  var bar = document.getElementById('azOrderBar');
  var fab = document.getElementById('azOrderFab');
  if (fab) {
    var fabHTML = fab.innerHTML;
    fab.addEventListener('click', function () { openOrder(fab, null, fabHTML); });
  }
  if (bar) {
    /* اترك مساحة أسفل الصفحة بقدر ارتفاع الشريط حتى لا يغطّي المحتوى،
       وأبلغ زر واتساب بالارتفاع ليقف فوقه. */
    var syncHeight = function () {
      var h = bar.offsetHeight;
      if (!h) return;
      document.documentElement.style.setProperty('--az-fab-h', h + 'px');
      document.body.style.paddingBottom = h + 'px';
    };
    syncHeight();
    window.addEventListener('resize', syncHeight);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncHeight);
    if ('ResizeObserver' in window) new ResizeObserver(syncHeight).observe(bar);
  }

  /* ---------- 3) زر السلة ----------
     رابطه ينقل إلى صفحة المنتج ومعه ‎?order=1‎ فتُفتح الاستمارة هناك.
     وإن كان التطبيق يعرض زرًّا في صفحة السلة أيضًا، نفتحه فورًا. */
  var cartBtn = document.getElementById('azCartCheckout');
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      var trigger = findEasySellTrigger();
      if (trigger) {
        e.preventDefault();
        trigger.click();
      }
    });
  }

  /* ---------- 4) الفتح التلقائي عبر ‎?order=1 ----------
     زر التطبيق يوجد في الصفحة قبل أن يربط التطبيق حدث الضغط عليه،
     لذلك نُعيد المحاولة حتى تُفتح النافذة فعلًا لا حتى يوجد الزر فقط. */
  if (/[?&]order=1(&|$)/.test(window.location.search)) {
    var tries = 0;

    var stop = function (scrollFallback) {
      clearInterval(timer);
      history.replaceState({}, '', window.location.pathname);
      if (scrollFallback) {
        var target = document.getElementById('az-order');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    var timer = setInterval(function () {
      tries++;
      if (isModalOpen()) { stop(false); return; }
      if (window.easysellApp) {
        var trigger = findEasySellTrigger();
        if (trigger) trigger.click();
      }
      if (tries > 30) { stop(true); }
    }, 400);
  }
})();